import * as types from '../types'

export default (payload) => {
  return {
    type: types.POST_JOB,
    payload,
  }
}
